import { computed, ref } from 'vue';
import type { WritableComputedRef } from 'vue';

export default function storage<T>(key: string): WritableComputedRef<T | null> & { remove: () => void };
export default function storage<T>(key: string, defaultValue: T): WritableComputedRef<T> & { remove: () => void };
export default function storage<T>(key: string, defaultValue?: T) {
  const trigger = ref(0);

  const item = computed<T | null>({
    get: () => {
      void trigger.value;

      const raw = localStorage.getItem(key);
      try {
        return raw !== null ? JSON.parse(raw) : defaultValue ?? null;
      } catch {
        return raw ?? defaultValue ?? null;
      }
    },
    set: (val) => {
      localStorage.setItem(key, typeof val === 'string' ? val : JSON.stringify(val));
      trigger.value++;
    },
  });

  window.addEventListener('storage', (e) => {
    if (e.key === key) {
      trigger.value++;
    }
  });

  const result = item as WritableComputedRef<T | null> & { remove: () => void };

  result.remove = () => {
    localStorage.removeItem(key);
    trigger.value++;
  };

  return result;
}
